import videojs from 'video.js';

import { initAdPlugin } from './ads/ad-plugin';
import { initAnalyticsPlugin } from './analytics';
import { initChromecastPlugin } from './chromecast';

let pluginsInjected = false;

export function ensureVideojsIsInitialized(vjs: typeof videojs) {
  if (pluginsInjected) {
    return;
  }
  initAnalyticsPlugin();
  initAdPlugin();
  initChromecastPlugin(vjs);
  pluginsInjected = true;
}
